import { ReactNode, RefObject } from "react";
import { CSSTransition } from "react-transition-group";
import isMobile from "src/helpers/isMobile";

interface AnimateProps {
	children: ReactNode;
	nodeRef?: RefObject<HTMLElement | null>;
	isOpen: boolean;
	className?: string;
	animationClassName?: string;
	timeout?: number;
}

export function Animate({
	children,
	nodeRef,
	isOpen,
	className,
	animationClassName,
	timeout,
}: AnimateProps) {
	if (isMobile()) {
		if (!isOpen) {
			return null;
		}

		return <div className={className}>{children}</div>;
	}

	return (
		<CSSTransition
			in={isOpen}
			timeout={timeout}
			classNames={animationClassName}
			unmountOnExit
			nodeRef={nodeRef}
		>
			{children}
		</CSSTransition>
	);
}
